import { ApplicationState } from '../../reducers'
import CollectionSlider, { FieldProps } from './CollectionSlider'
import Collection from '../../models/collection'
import { connect } from 'react-redux'
import { dataLayerPushEvent } from '../../services/gtm'
import { currentEventSelector } from '../../data/selectors'
import { getCategoryUrlFromCategories, findCategoryBySlug } from '../category/utilities'

type OwnProps = {
    collectionSlug: string
    shuffle?: boolean
}

type MethodProps = {
    sliderScrollHandler: (collection: Collection) => void
}

const eventHandler = (collection: Collection) => {
    return (dispatch: any, getState: () => ApplicationState) => {
        dataLayerPushEvent('customScrollEvent', '', collection.title)
    }
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps): FieldProps => {
    const collection = state.data.collections[ownProps.collectionSlug]
    if (collection === undefined) {
        return {}
    }

    const currentEvent = currentEventSelector(state)

    // get category name by collection categorySlug, get category link by slug
    let categoryName
    let categoryLink
    if (currentEvent !== undefined && currentEvent.categories !== undefined) {
        const matchedCollection = state.data.collections[collection.slug]
        if (matchedCollection !== undefined && matchedCollection.categorySlug !== undefined) {
            const matchedCategory = findCategoryBySlug(currentEvent.categories, matchedCollection.categorySlug)
            categoryLink = getCategoryUrlFromCategories(currentEvent.categories, matchedCollection.categorySlug)
            if (matchedCategory !== undefined) {
                categoryName = matchedCategory.category.name
            }
        }
    }

    let deals
    if (collection.deals !== undefined) {
        deals = collection.deals
        .sort((a, b) => Number(a.position) - Number(b.position))
        .map(deal => state.data.deals[deal.slug])
        .filter(deal => deal !== undefined)
    }

    return {
        collection,
        deals,
        categoryName,
        categoryLink,
        shuffle: ownProps.shuffle,
    }
}

const actions: MethodProps = {
    sliderScrollHandler: eventHandler,
}

export default connect(
    mapStateToProps,
    actions
)(CollectionSlider)
